import {Link} from "react-router-dom";
import "./styles/cia.scss";
import { motion } from "framer-motion"
import ServiceNavbar from "../cpa/components/ServiceNavbar";

function Cia() {
    return (
        <>
            {/* <!-- banner --> */}
            <div className="banner">
                <motion.div
                        initial={{ opacity: 0, x:-100 }}
                        whileInView={{ opacity: 1, x:0 }}
                        transition={{
                        delay: 0.4,
                        default: { ease: "linear" },
                        }}>
                    <img src="./cpaImg/CPA.jpg" alt=""/>
                </motion.div>
                <div className="cpabannertext dis">
                    Becker<br/>
                    CIA<br/>
                    <div className="fx dis">
                        <button type="button" className="btn btn-outline-secondary dis"><a href="#why" className="text-secondary">詳情介紹</a></button>
                        <button type="button" className="btn btn-secondary dis me-3"><Link className="text-light" to={`/registration/plan?parent_id=8`}>申請報名</Link></button>
                    </div>
                </div>
            </div>
            {/* <!-- Service Nav--> */}
            <ServiceNavbar/>
            <div class="becker-cia-page">

                {/* <!-- HEADER --> */}
                {/* <header class="cia-header">
                    <div class="cia-header-inner">
                        <div class="cia-logo-placeholder">
                            <div class="logo-img">
                                <!-- 請自行替換為 <img src="..." alt="Becker" /> -->
                                BECKER+
                            </div>
                        </div>
                        <span class="cia-header-badge">CIA 備考方案</span>
                    </div>
                </header> */}

                {/* <!-- HERO --> */}
                <section class="cia-hero">
                    <div class="cia-container">
                        <span class="cia-hero-eyebrow">全球唯一 · 最具權威</span>
                        <h1>CIA 國際內部稽核師證照<br/>完整介紹與備考指南</h1>
                        <p class="cia-hero-subtitle">
                            考試架構、報考路徑與 Challenge Exam 快速通道完整解析：從零基礎到取得 CIA，一頁掌握所有關鍵資訊。
                        </p>
                        <div class="cia-hero-stats">
                            <div class="cia-stat">
                                <span class="cia-stat-number">20萬+</span>
                                <span class="cia-stat-label">全球持證專業人士</span>
                            </div>
                            <div class="cia-stat">
                                <span class="cia-stat-number">170+</span>
                                <span class="cia-stat-label">國家認可</span>
                            </div>
                            <div class="cia-stat">
                                <span class="cia-stat-number">1974</span>
                                <span class="cia-stat-label">年設立至今</span>
                            </div>
                        </div>
                    </div>
                </section>

                {/* <!-- BODY --> */}
                <main class="cia-body">
                    <div class="cia-container">

                        {/* <!-- SECTION 1: 專業價值 --> */}
                        <section class="cia-section">
                            <h2 class="cia-section-title">
                                <span class="cia-section-num">1</span>
                                CIA 證照的專業價值與最新發展
                            </h2>
                            <p class="cia-prose">
                                國際內部稽核師（Certified Internal Auditor®, CIA®）自 1974 年設立以來，是全球內部稽核領域唯一且最具權威性的專業證照。該證照由國際內部稽核協會（IIA）頒發，目前全球已有超過 20 萬名專業人士取得資格，具備高度國際認可度與職涯價值。
                            </p>
                            <p class="cia-prose">
                                取得 CIA 證照，代表具備執行內部稽核工作的核心知識、技能與專業判斷能力，並能依循國際標準提供高品質的稽核服務。IIA 已更新 CIA 考試大綱，使其與《全球內部稽核準則》（Global Internal Audit Standards™）一致，強化風險導向與實務應用能力。
                            </p>
                            <div class="cia-infobox">
                                <p><strong>AI 時代下的 CIA 證照定位</strong></p>
                                <p>
                                    在生成式 AI 與自動化技術快速發展的環境中，企業風險已從傳統財務與流程控制，擴展至演算法偏誤、資料治理、模型透明度與決策風險。IIA 最新準則與考試內容已將資料分析、資訊安全與新興科技風險納入核心範疇，要求內部稽核人員具備科技理解與風險評估能力。
                                </p>
                            </div>
                        </section>

                        {/* <!-- SECTION 2: 薪資優勢 --> */}
                        <section class="cia-section">
                            <h2 class="cia-section-title">
                                <span class="cia-section-num">2</span>
                                CIA 證照的薪資優勢
                            </h2>
                            <div class="cia-salary-banner">
                                <span class="cia-salary-number">+37–50%</span>
                                <div class="cia-salary-desc">
                                    根據 IIA Internal Audit Compensation Study，<strong>持有 CIA 證照的專業人士，在薪資水準上顯著高於未持證者約 37% 至 50%。</strong><br/>此差距反映企業對具備內部稽核與風險治理能力人才的高度需求。
                                </div>
                            </div>
                            <p class="cia-prose">
                                CIA 證照持有人通常能在風險管理、內部控制與公司治理中發揮更高價值，進而體現在薪酬與職涯發展上。
                            </p>
                        </section>

                        {/* <!-- SECTION 3: 考試架構 --> */}
                        <section class="cia-section">
                            <h2 class="cia-section-title">
                                <span class="cia-section-num">3</span>
                                CIA 考試結構與報考條件
                            </h2>

                            <h3 class="cia-section-sub">考試科目架構</h3>
                            <p class="cia-prose">CIA 傳統考試分為三個部分，考試內容涵蓋治理、風險管理、內部控制、資訊科技與數據分析等核心領域：</p>

                            <div class="cia-parts-grid">
                                <div class="cia-part-card">
                                    <div class="cia-part-label">Part 1</div>
                                    <div class="cia-part-title">內部稽核基礎</div>
                                    <div class="cia-part-tags">
                                        <span class="cia-tag">治理</span>
                                        <span class="cia-tag">風險管理</span>
                                        <span class="cia-tag">內部控制</span>
                                    </div>
                                </div>
                                <div class="cia-part-card">
                                    <div class="cia-part-label">Part 2</div>
                                    <div class="cia-part-title">內部稽核實務</div>
                                    <div class="cia-part-tags">
                                        <span class="cia-tag">稽核規劃</span>
                                        <span class="cia-tag">執行技術</span>
                                        <span class="cia-tag">溝通報告</span>
                                    </div>
                                </div>
                                <div class="cia-part-card">
                                    <div class="cia-part-label">Part 3</div>
                                    <div class="cia-part-title">內部稽核知識要素</div>
                                    <div class="cia-part-tags">
                                        <span class="cia-tag cia-tag-highlight">數據分析</span>
                                        <span class="cia-tag cia-tag-highlight">資訊安全</span>
                                        <span class="cia-tag cia-tag-highlight">科技與控制</span>
                                    </div>
                                </div>
                            </div>

                            <h3 class="cia-section-sub">報考資格條件</h3>
                            <p class="cia-prose">申請 CIA 計畫並獲核准後，考生需於三年內完成所有要求：通過考試、完成學歷驗證、完成工作經驗認證。</p>

                            <div class="cia-table-wrapper">
                                <table class="cia-table">
                                    <thead>
                                        <tr>
                                            <th>學歷</th>
                                            <th>所需工作經驗</th>
                                            <th>備註</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>碩士（含以上）</td>
                                            <td>1 年相關經驗</td>
                                            <td>需完成三科考試</td>
                                        </tr>
                                        <tr>
                                            <td>學士</td>
                                            <td>2 年相關經驗</td>
                                            <td>需完成三科考試</td>
                                        </tr>
                                        <tr>
                                            <td>美國 CPA / CISA / ACCA 等</td>
                                            <td>依資格而定</td>
                                            <td>可申請 Challenge Exam（單科通關）</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>

                        {/* <!-- SECTION 4: Challenge Exam --> */}
                        <section class="cia-section">
                            <h2 class="cia-section-title">
                                <span class="cia-section-num">4</span>
                                CIA Challenge Exam：快速取證通道
                            </h2>
                            <p class="cia-prose">
                                CIA Challenge Exam 是 IIA 提供的專業快速通道，符合資格者只需通過單一科目，即可完成 CIA 考試要求。
                            </p>

                            <div class="cia-challenge-box">
                                <div class="cia-challenge-header">
                                    <h3>Challenge Exam 詳情</h3>
                                    <span class="cia-challenge-badge">快速通道</span>
                                </div>
                                <div class="cia-challenge-body">
                                    <div>
                                        <div class="cia-challenge-col-title">考試形式</div>
                                        <div class="cia-format-grid">
                                            <div class="cia-format-item">
                                                <div class="cia-format-label">題型</div>
                                                <div class="cia-format-value">選擇題</div>
                                            </div>
                                            <div class="cia-format-item">
                                                <div class="cia-format-label">題數</div>
                                                <div class="cia-format-value">約 150 題</div>
                                            </div>
                                            <div class="cia-format-item">
                                                <div class="cia-format-label">時間</div>
                                                <div class="cia-format-value">約 180 分鐘</div>
                                            </div>
                                            <div class="cia-format-item">
                                                <div class="cia-format-label">語言</div>
                                                <div class="cia-format-value">英文</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="cia-challenge-col-title">適用對象</div>
                                        <ul class="cia-checklist">
                                            <li>美國 CPA（美國註冊會計師）</li>
                                            <li>CISA 資訊系統稽核師</li>
                                            <li>ACCA 英國特許公認會計師</li>
                                            <li>CA 及其他認可國際資格</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="cia-infobox">
                                <p>對於已具備會計專業執照、或資訊稽核背景者，Challenge Exam 不僅是縮短考試時間的工具，更是一個將既有專業能力延伸至「數位治理與 AI 風險」領域的途徑。透過 CIA 架構，專業人士能從財務或資訊審計角色，擴展至企業整體風險與技術治理層級。<a href="https://www.beckertw.com/home/newdetail/658" target="_blank">了解更多關於 Challenge Exam &gt;&gt;</a></p>
                            </div>
                        </section>

                        {/* <!-- SECTION 5: 取得流程 --> */}
                        <section class="cia-section">
                            <h2 class="cia-section-title">
                                <span class="cia-section-num">5</span>
                                CIA 證照取得流程
                            </h2>

                            <div class="cia-steps">
                                <div class="cia-step">
                                    <div class="cia-step-left">
                                        <div class="cia-step-dot">1</div>
                                        <div class="cia-step-line"><br/></div>
                                    </div>
                                    <div class="cia-step-body">
                                        <div class="cia-step-title">提交申請（CCMS 系統）</div>
                                        <div class="cia-step-desc">於 IIA 官方 CCMS 系統建立帳號，填寫學歷與工作經驗資料並提交審核。</div>
                                    </div>
                                </div>
                                <div class="cia-step">
                                    <div class="cia-step-left">
                                        <div class="cia-step-dot">2</div>
                                        <div class="cia-step-line"><br/></div>
                                    </div>
                                    <div class="cia-step-body">
                                        <div class="cia-step-title">預約並完成考試</div>
                                        <div class="cia-step-desc">申請核准後，於 Pearson VUE 考試中心預約考期，依序完成 Part 1–3（或 Challenge Exam）。</div>
                                    </div>
                                </div>
                                <div class="cia-step">
                                    <div class="cia-step-left">
                                        <div class="cia-step-dot">3</div>
                                        <div class="cia-step-line"><br/></div>
                                    </div>
                                    <div class="cia-step-body">
                                        <div class="cia-step-title">完成工作經驗驗證</div>
                                        <div class="cia-step-desc">提交符合 IIA 要求的工作年資與主管簽核，完成內部稽核相關工作經驗認定。</div>
                                    </div>
                                </div>
                                <div class="cia-step">
                                    <div class="cia-step-left">
                                        <div class="cia-step-dot">4</div>
                                        <div class="cia-step-line"><br/></div>
                                    </div>
                                    <div class="cia-step-body">
                                        <div class="cia-step-title">取得 CIA 證照</div>
                                        <div class="cia-step-desc">所有要求完成後，由 IIA 正式頒發 CIA 證照及數位徽章。</div>
                                    </div>
                                </div>
                                <div class="cia-step">
                                    <div class="cia-step-left">
                                        <div class="cia-step-dot">5</div>
                                    </div>
                                    <div class="cia-step-body">
                                        <div class="cia-step-title">每年完成 CPE 持續進修</div>
                                        <div class="cia-step-desc">每年須完成 40 小時繼續教育（CPE），確保知識與時俱進，維持證照有效。</div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* <!-- SECTION 6: Becker 教材 --> */}
                        <section class="cia-section">
                            <h2 class="cia-section-title">
                                <span class="cia-section-num">6</span>
                                Becker CIA 官方教材與學習方案
                            </h2>
                            <p class="cia-prose">
                                Becker 與 IIA 官方合作推出 CIA Exam Review 系統，提供完整備考資源，協助考生以最有效率的方式通過考試。
                            </p>

                            <div class="cia-product-section">
                                {/* <!-- 產品示意圖可在此插入 --> */}
                                {/* <!-- <img src="product-mockup.png" alt="Becker CIA Exam Review" style="border-radius:4px;margin-bottom:24px;" /> --> */}

                                <div class="cia-product-title">Becker CIA Exam Review</div>
                                <div class="cia-product-sub">IIA 官方合作 · 完整備考系統</div>

                                <div class="cia-features-grid">
                                    <div class="cia-feature-card">
                                        <div class="cia-feature-icon">
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="7" cy="7" r="6" stroke="#122048" stroke-width="1.5"></circle>
                                                <path d="M5 7l1.5 1.5L9 5" stroke="#122048" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                                            </svg>
                                        </div>
                                        <div class="cia-feature-name">Newt™ AI 學習助手</div>
                                        <div class="cia-feature-desc">個人化 AI 輔助，即時解答考題疑難。</div>
                                    </div>
                                    <div class="cia-feature-card">
                                        <div class="cia-feature-icon">
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="1" y="1" width="12" height="12" rx="2" stroke="#122048" stroke-width="1.5"></rect>
                                                <path d="M4 7h6M4 4.5h6M4 9.5h4" stroke="#122048" stroke-width="1.2" stroke-linecap="round"></path>
                                            </svg>
                                        </div>
                                        <div class="cia-feature-name">Adapt2U 自適應題庫</div>
                                        <div class="cia-feature-desc">依個人弱點自動調整練習題方向。</div>
                                    </div>
                                    <div class="cia-feature-card">
                                        <div class="cia-feature-icon">
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M7 1v3M7 10v3M1 7h3M10 7h3" stroke="#122048" stroke-width="1.5" stroke-linecap="round"></path>
                                                <circle cx="7" cy="7" r="3" stroke="#122048" stroke-width="1.5"></circle>
                                            </svg>
                                        </div>
                                        <div class="cia-feature-name">全真模擬考</div>
                                        <div class="cia-feature-desc">與正式考試同等情境，精準評估備考狀態。</div>
                                    </div>
                                    <div class="cia-feature-card">
                                        <div class="cia-feature-icon">
                                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="7" cy="4" r="2.5" stroke="#122048" stroke-width="1.5"></circle>
                                                <path d="M2 12c0-2.761 2.239-5 5-5s5 2.239 5 5" stroke="#122048" stroke-width="1.5" stroke-linecap="round"></path>
                                            </svg>
                                        </div>
                                        <div class="cia-feature-name">專業講師解析</div>
                                        <div class="cia-feature-desc">資深講師深度講解重點題型與概念。</div>
                                    </div>
                                </div>

                                <div class="cia-plans-row">
                                    <div class="cia-plan-card">
                                        <div class="cia-plan-name">CIA 三科完整方案</div>
                                        <div class="cia-plan-desc">涵蓋 Part 1、2、3 完整教材，適合從零開始備考的考生。</div>
                                        <a href="https://www.beckertw.com/registration/plan?parent_id=8" class="cia-plan-link" target="_blank" rel="noopener">立即購買 →</a>
                                    </div>
                                    <div class="cia-plan-card">
                                        <div class="cia-plan-name">Challenge Exam 單科方案</div>
                                        <div class="cia-plan-desc">專為 CPA、CISA、ACCA 等持證人士設計的快速通關方案。</div>
                                        <a href="https://www.beckertw.com/registration/plan?parent_id=8" class="cia-plan-link" target="_blank" rel="noopener">立即購買 →</a>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* <!-- CONCLUSION --> */}
                        <section class="cia-section">
                            <h2 class="cia-section-title">
                                <span class="cia-section-num">7</span>
                                結語：從考試準備走向數位時代的專業能力
                            </h2>
                            <div class="cia-conclusion">
                                <p>CIA 證照的價值，已從單純的稽核知識認證，轉變為企業在數位轉型過程中所需的核心能力之一。在 AI 與自動化技術持續發展的環境中，企業需要能夠理解技術、辨識風險並進行治理的專業人才。</p>
                                <p>CIA 所建立的專業架構，使持證者具備跨財務、營運與科技的整合能力，能在快速變動的環境中維持專業判斷與治理能力。對於不同背景的考生：初學者可透過三科考試建立完整基礎，已持證專業人士可透過 Challenge Exam 提升轉換效率。</p>
                                <p>CIA 證照所代表的，不僅是考試通過與否，而是在長期職涯中，是否具備持續適應技術變化與風險環境的能力。</p>
                            </div>
                        </section>

                    </div>
                </main>

            </div>
        </>
    );
}
export default Cia;